import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import { KeyboardArrowDown } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import BasketIcon from '../../icons/BasketIcon';
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../../other/translate.json';
import Grid from "@material-ui/core/Grid";
import Link from '@material-ui/core/Link';
import { ruRU } from '@material-ui/core/locale';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import FavoriteButton from "../Favorites/FavoriteButton";
import utils from "../../other/utils";

const theme = createMuiTheme({
	palette: {
		primary: { main: '#1976d2' },
	},
}, ruRU);

function descendingComparator(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

function getComparator(order, orderBy) {
	if (orderBy === 'AsvulCode') { orderBy = 'Title' }
	if (orderBy === 'datestartsale') { orderBy = 'sortingdatestartsale' }

	return order === 'desc'
		? (a, b) => descendingComparator(a, b, orderBy)
		: (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator, init = false) {
	if (init) {
		return array
	}
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

function union(setA) {
	let unionArr = [];

	setA.forEach(el => {
		if (unionArr.includes(el)) {

		} else {
			unionArr.push(+el)
		}
	})
	return unionArr
}

function EnhancedTableHead(props) {
	const { classes, order, orderBy, onRequestSort, inCu } = props;
	const lang = localStorage.getItem('language') || 'Ru';

	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};

	const headCells = [
		{ id: 'AsvulCode', numeric: false, disablePadding: false, label: translate.Words[`Name${lang}`] },
		{ id: 'GroupTitle', numeric: false, disablePadding: false, label: translate.Words[`Group${lang}`] },
		{ id: 'SubGroupTitle', numeric: false, disablePadding: false, label: translate.Words[`SubGroup${lang}`] },
		{ id: 'Apps', numeric: false, disablePadding: false, sortable: false, label: translate.Words[`Applications_${lang}`] },
		{ id: 'Price', numeric: false, disablePadding: false, sortable: false, label: translate.Words[`TotalAppCost${lang}`] + ' ' + utils.getPriceItem(inCu, lang, 'elp') },
		{ id: 'Cart', numeric: false, disablePadding: false, sortable: false, label: translate.Words[`Add${lang}`] },
	];

	return (
		<React.Fragment>
			<TableHead>
				<TableRow>
					{headCells.map((headCell) => (
						<TableCell
							className={classes.THCellCap2}
							key={headCell.id}
							align='left'
							padding={headCell.disablePadding ? 'none' : 'default'}
							sortDirection={orderBy === headCell.id ? order : false}
						>
							{
								headCell.id !== 'Apps' && headCell.id !== 'Price' && headCell.id !== 'Cart'
									?
									<TableSortLabel
										active={orderBy === headCell.id}
										direction={orderBy === headCell.id ? order : 'asc'}
										onClick={createSortHandler(headCell.id)}
										IconComponent={KeyboardArrowDown}
									>
										{headCell.label}
										{
											orderBy === headCell.id
												?
												(<span className={classes.visuallyHidden}>
													{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
												</span>)
												:
												null
										}
									</TableSortLabel>
									:
									// cart && headCell.label === 'Добавить в корзину' ? 'Удалить из корзины' :
									headCell.label

							}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		</React.Fragment>
	);
}

EnhancedTableHead.propTypes = {
	classes: PropTypes.object.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	// onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		padding: '0 12px',
		marginTop: 12,
	},

	paper: {
		width: '100%',
		marginBottom: theme.spacing(2),
		borderRadius: theme.spacing(2),
		padding: '0 31px',
	},

	table: {
		minWidth: 750,
	},

	visuallyHidden: {
		border: 0,
		clip: 'rect(0 0 0 0)',
		height: 1,
		margin: -1,
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		top: 20,
		width: 1,
	},

	GroupTitleCell: {
		minWidth: 260,
		width: 260,
		maxWidth: 260,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			minWidth: 202,
			width: 202,
			maxWidth: 202,
		}
	},

	SubGroupTitleCell: {
		minWidth: 212,
		width: 212,
		maxWidth: 212,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			minWidth: 122,
			width: 122,
			maxWidth: 122,
		}
	},

	AppsCountCell: {
		minWidth: 223,
		width: 223,
		maxWidth: 223,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',
	},

	AppsSumCell: {
		minWidth: 191,
		width: 191,
		maxWidth: 191,
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',

		[theme.breakpoints.between(1366, 1702)]: {
			minWidth: 104,
			width: 104,
			maxWidth: 104,
		}
	},

	CartCell: {
		minWidth: 58,
		width: 58,
		maxWidth: 58
	},

	TCellCap2B: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '700',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#24262A',
		verticalAlign: 'top',
	},


	TCellCap2: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',
	},

	THCellCap2: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2',
		verticalAlign: 'bottom',
		padding: '16px 12px',
	},

	TCellCap1: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '13px',
		lineHeight: '16px',
		color: '#24262A',
		padding: '16px 12px',
		verticalAlign: 'top',
	},

	icon: {
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	LinkType12: {
		fontSize: '13px',
		lineHeight: '16px',
		fontWeight: 400,
		color: '#24262A',
		textDecoration: 'none',
		borderBottom: '1px dashed rgba(0, 0, 0, 0.4)',

		'&:hover': {
			color: '#2050FF',
			textDecoration: 'none',
			borderBottom: '1px dashed #2050FF',
		}
	},
}));

export default function EnhancedTable(props) {
	let { cardArr, checkAll, setCheckAll, cart, page, setPage, rowsPerPage, setRowsPerPage , isSearch} = props
	let inCu = props.userCollection.CatalogCu || props.userCollection.inCu;

	// const [basketChips, _appBasket] = useState(JSON.parse(localStorage.getItem('cartApp')) || [])
	const classes = useStyles();
	const [order, setOrder] = React.useState('asc');
	const [orderBy, setOrderBy] = React.useState('AsvulCode');
	const lang = localStorage.getItem('language') || 'Ru';
	const [init, _init] = React.useState(true);
	// const [rowsPerPage, setRowsPerPage] = React.useState(50);
	const [appBasket, _appBasket] = useState(JSON.parse(localStorage.getItem('cartApp')) || []);
	const [prodBasket, _prodBasket] = useState(JSON.parse(localStorage.getItem('cartProd')) || []);

	const renderFavoritesIcon = (row, isCart, productFavorite) => {
		let productInFavorite = productFavorite && productFavorite.includes(row.ID);
		let title = productInFavorite ? translate.Words[`RemoveFromFavorite${lang}`] : translate.Words[`AddToFavorite${lang}`];
		let fill = productInFavorite ? '#FFFFFF' : '#BCBBD0';
		let onClick = /*isBasket ?*/ () => { props.saveCollection(row.ID, 'product', 'favorite', [].concat(row.AppsIDsNeeded.split(',').map(el => +el.trim()), row.AppsIDsRecommended.split(',').map(el => +el.trim()))); if (isCart && !!props.updateArr) { props.updateArr('favorite', row, 'product'); } };
		let backgroundColor = productInFavorite ? '#EB505E' : undefined;


		return (
			<FavoriteButton fill={fill} title={title} onClick={onClick} needMarginBottom backgroundColor={backgroundColor} />
		)
	}

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
		_init(false);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
		window.scrollTo(0, 0)
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const setAppProd = (prod) => {
		if (prodBasket.some((element) => element === prod.ID) === true) {
			_prodBasket(prodBasket.filter(el_ => el_ !== prod.ID))
			localStorage.setItem('cartProd', JSON.stringify(prodBasket.filter(el_ => el_ !== prod.ID)))
			let arr_ = []
			appBasket.forEach(el => {
				if (prod['AppsIDsNeeded'] && prod['AppsIDsRecommended'] && prod['AppsIDsNeeded'].length + prod['AppsIDsRecommended'].length > 0 && prod['AppsIDsNeeded'].concat(`,${prod['AppsIDsRecommended']}`).includes(el)) {

				} else {
					arr_.push(el)
				}
			})
			_appBasket(arr_)
			localStorage.setItem('cartApp', JSON.stringify(union(arr_)))

		} else {
			_prodBasket(prodBasket.concat([prod.ID]))
			localStorage.setItem('cartProd', JSON.stringify(prodBasket.concat([prod.ID])))
			if (prod['AppsIDsNeeded'] === null && prod['AppsIDsRecommended'] === null) {
			}
			else if (prod['AppsIDsNeeded'].length + prod['AppsIDsRecommended'].length > 0) {
				let need__ = prod['AppsIDsNeeded'].length > 0 ? prod['AppsIDsNeeded'].split(',') : []
				let recom__ = prod['AppsIDsRecommended'].length > 0 ? prod['AppsIDsRecommended'].split(',') : []
				_appBasket(appBasket.concat(need__.concat(recom__)))
				localStorage.setItem('cartApp', JSON.stringify(union(appBasket.concat(need__.concat(recom__)))))
			}
			else {
			}

		}
	}

	const setAppProd_ = (prod, e) => {
		let prodBasket_ = JSON.parse(localStorage.getItem('cartProd')) || [];

		setAppProd(prod);
		if (prodBasket_.some((element) => element === prod.ID) === true) {
			_prodBasket(prodBasket_.filter(el_ => el_ !== prod.ID))
		} else {
			_prodBasket(prodBasket_.concat(prod.ID))

		}

		// setCheckAll(isAll)
	}

	useEffect(() => {
		if (!cart) {
			let prodBasket_ = JSON.parse(localStorage.getItem('cartProd')) || [];
			let isAll = cardArr.every(el => prodBasket_.includes(el.ID))
			setCheckAll(isAll)
		}
	}, [cardArr, checkAll, setAppProd_]);

	function SkeletonRow() {
		return (
			<TableRow tabIndex={-1}>
				<TableCell align="left" className={classes.TCellCap2B} style={{ padding: '16px 12px' }}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.GroupTitleCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.SubGroupTitleCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.AppsCountCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.AppsSumCell}>
					<Skeleton animation="wave" variant="rect" height={48} />
				</TableCell>

				<TableCell align="left" className={classes.CartCell} style={{ minWidth: 82, width: 82, maxWidth: 82 }}>
					<Skeleton animation="wave" variant="circle" height={48} />
				</TableCell>
			</TableRow>
		)
	}

	

	return (
		<ThemeProvider theme={theme}>
			<div className={classes.root}>
				{props.cardArr.length > 0 || props.loading
					?
					<Paper className={classes.paper}>
						<TableContainer>
							<Table
								className={classes.table}
								aria-labelledby="tableTitle"
								aria-label="enhanced table"
							>
								<EnhancedTableHead
									classes={classes}
									order={order}
									orderBy={orderBy}
									cart={cart}
									// onSelectAllClick={handleSelectAllClick}
									onRequestSort={handleRequestSort}
									rowCount={props.cardArr.length}
									inCu={inCu}
								/>
								<TableBody>
									{
										props.loading
											?
											<React.Fragment>
												{SkeletonRow()}
											</React.Fragment>
											:
											stableSort(props.cardArr, getComparator(order, orderBy), init && isSearch === true)
												.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
												.map((row, index) => {
													// const isItemSelected = isSelected(row.title);
													// const labelId = `enhanced-table-checkbox-${index}`;

													return (
														// <Link href={`/${type}/card/${row['AsvulCode']}`} style={{ textDecoration: 'none' }} target="_blank">
														<TableRow
															// hover
															// onClick={(event) => handleClick(event, row.title)}
															// role="checkbox"
															// aria-checked={isItemSelected}
															tabIndex={-1}
															key={row.AsvulCode}
														// selected={isItemSelected}
														>
															<TableCell align="left" className={classes.TCellCap2B} style={{ padding: '16px 12px' /*, cursor: 'pointer' */ }} /* onClick={() => window.open(`/${type}/card/${row['AsvulCode']}`, "_blank")} */>
																<Link component="a" href={`/products/card/${row['ID']}`} target="_blank" color='inherit'>
																	<Grid item container direction="row" justify="flex-start" alignItems="center">
																		<div style={{ width: '100%', marginBottom: 8 }}>{row.Title}</div>

																		<br />
																		{
																			row.P_DirectionsID === 1
																				?
																				<CustomTooltip title={row.DirectionTitle} placement="right">
																					<div style={{ height: 12, width: 12, marginRight: 6, borderRadius: '6px', background: '#683EDF' }}></div>
																				</CustomTooltip>
																				:
																				''
																		}

																		{
																			row.P_DirectionsID === 2
																				?
																				<CustomTooltip title={row.DirectionTitle} placement="right">
																					<div style={{ height: 12, width: 12, marginRight: 6, borderRadius: '6px', background: '#D61C62' }}></div>
																				</CustomTooltip>
																				:
																				''
																		}

																		{
																			row.P_DirectionsID === 3
																				?
																				<CustomTooltip title={row.DirectionTitle} placement="right">
																					<div style={{ height: 12, width: 12, marginRight: 6, borderRadius: '6px', background: '#0A9539' }}></div>
																				</CustomTooltip>
																				:
																				''
																		}

																		{
																			row.P_DirectionsID === 4
																				?
																				<CustomTooltip title={row.DirectionTitle} placement="right">
																					<div style={{ height: 12, width: 12, marginRight: 6, borderRadius: '6px', background: '#06A1C2' }}></div>
																				</CustomTooltip>
																				:
																				''
																		}

																		{
																			row.P_DirectionsID === 5
																				?
																				<CustomTooltip title={row.DirectionTitle} placement="right">
																					<div style={{ height: 12, width: 12, marginRight: 6, borderRadius: '6px', background: '#4DBCCB' }}></div>
																				</CustomTooltip>
																				:
																				''
																		}
																	</Grid>

																	<br />

																	<div style={{ marginTop: 8 }}>{row.Title_catalog}</div>
																</Link>
															</TableCell>

															<TableCell align="left" className={classes.GroupTitleCell} /* onClick={() => window.open(`/applications/${row.url_catalog}/applist?filt=false&direction=${row.businessdirectionid}`)} */>
																{/* <Link component="a" href={`/applications/${row.url_catalog}/applist?filt=false&direction=${row.businessdirectionid}`} color='inherit'> */}
																{
																	props.loading === true
																		?
																		<Skeleton animation="wave" />
																		:
																		<Link component="a" href={`/products/cftbank/prodlist?group=${row.Icon_GroupID}`} className={classes.LinkType12}>
																			{row.GroupTitle}
																		</Link>
																}
																{/* </Link> */}
															</TableCell>

															<TableCell align="left" className={classes.SubGroupTitleCell}>
																<Link component="a" href={`/products/cftbank/prodlist?group=&subgroup=${row.SubGroupTitle}`} className={classes.LinkType12}>
																	{row.SubGroupTitle}
																</Link>
															</TableCell>

															<TableCell align="left" className={classes.AppsCountCell}>
																{
																	row.AppsIDsNeededCount > 0
																		?
																		<Grid container direction="row" alignItems="flex-start" style={{ justifyContent: "space-between", marginBottom: 8 }}>
																			<Grid item>{translate.Words[`LicensingRequired${lang}`]}</Grid>
																			<Grid item className={classes.TCellCap2B}>{row.AppsIDsNeededCount}</Grid>
																		</Grid>
																		:
																		null
																}

																{
																	row.AppsCodeRecommendedCount > 0
																		?
																		<Grid container direction="row" alignItems="flex-start" style={{ justifyContent: "space-between" }}>
																			<Grid item>{translate.Words[`RecommendedForLicensing${lang}`]}</Grid>
																			<Grid item className={classes.TCellCap2B}>{row.AppsCodeRecommendedCount}</Grid>
																		</Grid>
																		:
																		null
																}
															</TableCell>

															<TableCell align="left" className={classes.AppsSumCell}>
																<CustomTooltip title={<span>
																	{translate.Words[`CurrentRate_${lang}`]}
																	{/* <br />{translate.Words[`NextRate_${lang}`]} */}
																</span>}>
																	<div className={classes.TCellCap2B} style={{ marginBottom: 8 }}>
																		{row.AppsNeededSum}

																		{row.SumAppsNeeded}
																	</div>
																</CustomTooltip>

																<CustomTooltip title={<span>
																	{translate.Words[`CurrentRate_${lang}`]}
																	{/* <br />{translate.Words[`NextRate_${lang}`]} */}
																</span>}>
																	<div className={classes.TCellCap2B} style={{ color: '#8987A2' }}>
																		{
																			row.AppsCodeRecommendedCount > 0
																				?
																				row.AppsRecommendedSum !== "999999.0" && row.AppsRecommendedSum !== "0.0"
																					?
																					+row.AppsRecommendedSum == 0
																						?
																						translate.Words[`NotCharged${lang}`]
																						:
																						row.AppsRecommendedSum
																					:
																					0
																				:
																				null
																		}
																		{
																			row.AppsCodeRecommendedCount > 0
																				?
																				row.SumAppsRecommended !== "999999.0" && row.SumAppsRecommended !== "0.0"
																					?
																					+row.SumAppsRecommended == 0
																						?
																						translate.Words[`NotCharged${lang}`]
																						:
																						row.SumAppsRecommended
																					:
																					0
																				:
																				null
																		}
																	</div>
																</CustomTooltip>
															</TableCell>

															<TableCell align="left" className={classes.CartCell} style={{ minWidth: 82, width: 82, maxWidth: 82 }}>
																{cart
																	?
																	<div disablespacing="true" className={classes.actions}>
																		<Grid item>
																			{renderFavoritesIcon(row, cart, props.userCollection.productFavorite)}
																			<CustomTooltip placement="top" title={prodBasket && prodBasket.includes(row.ID) ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`]}>
																				<IconButton
																					onClick={() => { props.saveCollection(row.ID, 'product', 'cart', [].concat(row.AppsIDsNeeded.split(',').map(el => +el.trim()), row.AppsIDsRecommended.split(',').map(el => +el.trim()))); if (cart && !!props.updateArr) { props.updateArr('cart', row); } }}
																					aria-label="share"
																					className={classes.icon}
																					style={{ backgroundColor: (JSON.parse(localStorage.getItem('cartProd')) && JSON.parse(localStorage.getItem('cartProd')).includes(row.ID)) ? '#EB505E' : '' }}
																				>
																					<BasketIcon fill={(JSON.parse(localStorage.getItem('cartProd')) && JSON.parse(localStorage.getItem('cartProd')).includes(row.ID)) ? '#FFFFFF' : '#BCBBD0'} />
																				</IconButton>
																			</CustomTooltip>
																		</Grid>
																	</div>
																	:
																	<div disablespacing="true" className={classes.actions}>
																		<Grid item>
																			{renderFavoritesIcon(row, cart, props.userCollection.productFavorite)}
																			<CustomTooltip placement="top" title={prodBasket && prodBasket.includes(row.ID) ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`]}>
																				<IconButton
																					onClick={() => { props.saveCollection(row.ID, 'product', 'cart', [].concat(row.AppsIDsNeeded.split(',').map(el => +el.trim()), row.AppsIDsRecommended.split(',').map(el => +el.trim()))); if (cart && !!props.updateArr) { props.updateArr('cart', row); } }}
																					aria-label="share"
																					className={classes.icon}
																					style={{ backgroundColor: (JSON.parse(localStorage.getItem('cartProd')) && JSON.parse(localStorage.getItem('cartProd')).includes(row.ID)) ? '#EB505E' : '' }}
																				>
																					<BasketIcon fill={(JSON.parse(localStorage.getItem('cartProd')) && JSON.parse(localStorage.getItem('cartProd')).includes(row.ID)) ? '#FFFFFF' : '#BCBBD0'} />
																				</IconButton>
																			</CustomTooltip>
																		</Grid>
																	</div>
																}
															</TableCell>
															{/* </a> */}

														</TableRow>
														// </Link>
													);
												})
									}
								</TableBody>
							</Table>
						</TableContainer>

						{
							props.cardArr.length > 0 && !props.loading
							?
							<TablePagination
								rowsPerPageOptions={[50, 100, 150]}
								component="div"
								count={props.cardArr.length}
								rowsPerPage={rowsPerPage}
								page={page}
								onChangePage={handleChangePage}
								onChangeRowsPerPage={handleChangeRowsPerPage}
							/>
							:
							null
						}
					</Paper>
					:
					null
				}
			</div>
		</ThemeProvider >
	);
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);